export function isStringEmpty(unknown: unknown): boolean {
  return typeof unknown !== "string" || unknown.trim() === "";
}
